import Vue from 'vue';
import {Bar, Radar, Line, Doughnut} from 'vue-chartjs';
/**
 * vue-chartjs
 * https://vue-chartjs.org/guide/
 * https://www.chartjs.org/docs/latest/
 *
 */

Vue.component('VChartBar', Bar);
Vue.component('VChartRadar', Radar);
Vue.component('VChartLine', Line);
Vue.component('VChartDoughnut', Doughnut);
